import { DateService } from "../../../service/DateService";
import { IApplicantReportingPeriod } from "../../../model/applicant/ApplicantReportingPeriod";

export interface TApplicantReportingPeriodPresentationModel {
  id: number;
  applicantId: number;
  reportingPeriodId: number;
  fromPeriod?: string;
  toPeriod?: string;
  isEvaluationCandidate?: boolean;
  reportingPeriodName: string;
  reportingTypeName: string;
  hasRightOfEntry?: boolean;
  hasRightOfPreview?: boolean;
  evaluationReason: string;
  evaluationStatus: string;
  evaluationDate?: string;
}

const ApplicantReportingPeriodPresentationModel = (
  data: IApplicantReportingPeriod
): TApplicantReportingPeriodPresentationModel => {
  const fromPeriod = data.fromPeriod
    ? DateService().formatDate(data.fromPeriod)
    : undefined;
  const toPeriod = data.toPeriod
    ? DateService().formatDate(data.toPeriod)
    : undefined;
  const evaluationDate = data.evaluationDate
    ? DateService().formatDate(data.evaluationDate)
    : undefined;
  return {
    id: data.id,
    applicantId: data.applicantId,
    reportingPeriodId: data.applicantReportingPeriodId,
    fromPeriod,
    toPeriod,
    isEvaluationCandidate: data.isEvaluationCandidate,
    reportingPeriodName: data.reportingPeriodName,
    reportingTypeName: data.reportingTypeName,
    hasRightOfEntry: data.hasRightOfEntry,
    hasRightOfPreview: data.hasRightOfPreview,
    evaluationReason: data.evaluationReason,
    evaluationStatus: data.evaluationStatus,
    evaluationDate
  };
};

export default ApplicantReportingPeriodPresentationModel;
